const makeOrderArray = (string, defaultOrder, order) => {
  const currentOrder = string === ''
    ? defaultOrder
    : [{ field: '_score', direction: 'DESC' }, ...(order || defaultOrder)];

  return currentOrder;
};

export default makeOrderArray;
